import { Action } from '../../models/action';
import { createAction, props } from '@ngrx/store';
import { Quote } from '../../models/quote';
import { ServerMessage } from '../../models/server-message';

export const messengerActionUpdate = createAction(
    '[WSS] Action Update',
    props<{ action: Action }>()
);

export const messengerQuotingQueued = createAction(
    '[WSS] Quoting Queued',
    props<{ id: string }>()
);

export const messengerQuotingInProgress = createAction(
    '[WSS] Quoting In Progress',
    props<{ id: string, messages: ServerMessage[], progress: number, quotes: Quote[] }>()
);

export const messengerQuotingComplete = createAction(
    '[WSS] Quoting Complete',
    props<{ id: string, messages: ServerMessage[], quotes: Quote[], preSelectedId: string }>()
);

export const messengerQuotingMessage = createAction(
    '[WSS] Quoting Message',
    props<{ id: string, messages: ServerMessage[] }>()
);
